import { ajax } from '@/api/ajax';
import type { XDragonApiResponsePromise } from '@xpeng/xdragon-ass-components/es/services/ajax';

export interface BookmapParamMapReq {
  /**
   * 手册编码
   */
  bookmapCode: string;
  /**
   * 手册版本
   */
  bookmapVersion: string;
}

export type GetParamMapUsingPostApiResponse = Record<string, string>;

/**
 * @operationId getParamMapUsingPOST
 * @tags 手册
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-tis-cn-boot/doc.html#/%E6%89%8B%E5%86%8C/%E6%89%8B%E5%86%8C/getParamMapUsingPOST
 */
export function getParamMapUsingPost(
  data: BookmapParamMapReq
): XDragonApiResponsePromise<GetParamMapUsingPostApiResponse> {
  return ajax({
    url: '/api/tis/web/bookmap/param/getMap',
    method: 'post',
    data: data
  });
}
